/**
 * 轉倉尚未滿足。
 * @param {number} requiredQty 當前需求
 * @param {number} onHandQty 當前庫存（不含操作中）
 * @param {number} operatingQty 操作中數量
 * @param {{ includeOnHand?: boolean }} [options]
 *   `includeOnHand: false` 時不當庫存（指定工單模式）。
 */
export function calcUnsatisfiedQty(requiredQty, onHandQty, operatingQty, {
  includeOnHand = true,
} = {}) {
  const required = Number(requiredQty) || 0;
  const onHand = includeOnHand ? (Number(onHandQty) || 0) : 0;
  const operating = Number(operatingQty) || 0;
  return Math.max(0, required - onHand - operating);
}
